// Generated by scripts/generate-runtime-catalogs.mjs.
export const appCatalogLoaders = {
  "en": () => import("./runtime-catalogs/app/en.json").then(module => module.default),
  "es-ES": () => import("./runtime-catalogs/app/es-ES.json").then(module => module.default),
  "pt-BR": () => import("./runtime-catalogs/app/pt-BR.json").then(module => module.default),
  "fr": () => import("./runtime-catalogs/app/fr.json").then(module => module.default),
  "ar": () => import("./runtime-catalogs/app/ar.json").then(module => module.default),
  "nl": () => import("./runtime-catalogs/app/nl.json").then(module => module.default),
  "fil": () => import("./runtime-catalogs/app/fil.json").then(module => module.default),
  "de": () => import("./runtime-catalogs/app/de.json").then(module => module.default),
  "hi": () => import("./runtime-catalogs/app/hi.json").then(module => module.default),
  "it": () => import("./runtime-catalogs/app/it.json").then(module => module.default),
  "ms": () => import("./runtime-catalogs/app/ms.json").then(module => module.default),
  "ro": () => import("./runtime-catalogs/app/ro.json").then(module => module.default),
  "tr": () => import("./runtime-catalogs/app/tr.json").then(module => module.default),
  "af-ZA": () => import("./runtime-catalogs/app/af-ZA.json").then(module => module.default),
};
export const adminCatalogLoaders = {
  "en": () => import("./runtime-catalogs/admin/en.json").then(module => module.default),
  "es-ES": () => import("./runtime-catalogs/admin/es-ES.json").then(module => module.default),
  "pt-BR": () => import("./runtime-catalogs/admin/pt-BR.json").then(module => module.default),
  "fr": () => import("./runtime-catalogs/admin/fr.json").then(module => module.default),
  "ar": () => import("./runtime-catalogs/admin/ar.json").then(module => module.default),
  "nl": () => import("./runtime-catalogs/admin/nl.json").then(module => module.default),
  "fil": () => import("./runtime-catalogs/admin/fil.json").then(module => module.default),
  "de": () => import("./runtime-catalogs/admin/de.json").then(module => module.default),
  "hi": () => import("./runtime-catalogs/admin/hi.json").then(module => module.default),
  "it": () => import("./runtime-catalogs/admin/it.json").then(module => module.default),
  "ms": () => import("./runtime-catalogs/admin/ms.json").then(module => module.default),
  "ro": () => import("./runtime-catalogs/admin/ro.json").then(module => module.default),
  "tr": () => import("./runtime-catalogs/admin/tr.json").then(module => module.default),
  "af-ZA": () => import("./runtime-catalogs/admin/af-ZA.json").then(module => module.default),
};
